export default "__VITE_ASSET__CtVFT096__"